import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How many trailers do you have?", a: "We currently have two luxury restroom trailers." },
  { q: "How many stalls are in each trailer?", a: "Each trailer includes three private restroom stalls, for six total stalls when both are rented together." },
  { q: "Can I rent both trailers?", a: "Yes — you can request one trailer or both. Renting both is best for larger events or when you need restrooms in separate locations." },
  { q: "How far in advance should I book?", a: "We recommend booking as early as possible, especially for peak wedding and event seasons. Dates fill quickly." },
  { q: "Is a deposit required?", a: "Yes, a deposit is required to submit a booking request." },
  { q: "Is the deposit refundable?", a: "The deposit is refundable per our cancellation policy, which you'll review before submitting your booking." },
  { q: "When is the remaining balance due?", a: "The remaining balance is due before the event; your admin dashboard will send an automated reminder." },
  { q: "Do the trailers need power?", a: "Yes. Trailers require a standard power source. If none is available, we can provide a generator as an add-on." },
  { q: "Do the trailers need water?", a: "Yes. Water access is required. If unavailable, we can supply water as an add-on service." },
  { q: "Can you provide a generator?", a: "Yes — generator rental is available during the booking flow." },
  { q: "Are the trailers climate-controlled?", a: "Yes — each trailer includes climate control for comfort in any Southern Utah weather." },
  { q: "How many guests can the trailers support?", a: "As a general guideline, plan for up to ~150 guests per trailer; larger events benefit from both." },
  { q: "Do you deliver and set everything up?", a: "Yes — our team delivers, sets up, and picks up each trailer." },
  { q: "What areas do you serve?", a: "All of Southern Utah — see the Service Area page for the full list." },
  { q: "Can the trailers be used for multi-day events?", a: "Yes. Multi-day servicing is available as an add-on." },
  { q: "Do you offer attendants or additional servicing?", a: "Yes, both are optional add-ons." },
  { q: "What happens if my event is cancelled?", a: "Our cancellation policy is presented before booking. We'll always work with you where possible." },
  { q: "What happens during severe weather?", a: "Safety comes first; we'll coordinate with you to reschedule or adjust setup if conditions require it." },
];

export default function FAQs() {
  return (
    <div>
      <section className="section">
        <div className="mx-auto max-w-3xl">
          <div className="overline">Frequently Asked</div>
          <h1 className="h-display mt-3 text-5xl md:text-6xl leading-[1.05]">Answers, elegantly organized.</h1>
        </div>
      </section>

      <section className="pb-24 px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-3xl card-soft p-4 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={f.q} className="border-b border-stone last:border-0">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left text-base md:text-lg font-medium py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-graphite text-base leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
